<div class="my-feedback">
	<div class="mb-4 text-base font-bold text-black">{{ pageTitle }}</div>
	<div class="mb-4 flex flex-wrap items-start justify-between gap-x-4 gap-y-3">
		<div class="flex min-w-0 flex-1 flex-wrap items-center gap-3">
			<div class="w-full max-w-xs">
				<div class="relative">
					<mat-form-field appearance="outline" subscriptSizing="dynamic" class="form-field form-field-sm w-full">
						<input matInput [(ngModel)]="searchQuery" (input)="onSearch()" placeholder="Search" class="pr-10" />
						<img class="absolute right-1 top-1/2 w-3 -translate-y-1/2" src="/assets/icon_search.svg" alt="Search" />
					</mat-form-field>
				</div>
			</div>
			<div class="w-[220px] shrink-0">
				<mat-form-field appearance="outline" subscriptSizing="dynamic" class="form-field form-field-sm w-full">
					<mat-select [(value)]="selectedKind" (selectionChange)="onKindFilter()" placeholder="Type">
						<mat-option value="">All</mat-option>
						<mat-option value="standalone">Standalone</mat-option>
						<mat-option value="tied">Tied</mat-option>
					</mat-select>
					<img class="absolute right-1 top-1/2 w-3 -translate-y-1/2" src="/assets/icon_filter.svg" alt="Filter" />
				</mat-form-field>
			</div>
		</div>
		<app-cbta-daterange-filter
			class="ml-auto"
			[startDate]="startDate"
			[endDate]="endDate"
			(dateRangeSelected)="handleDateRangeChange($event)"
		></app-cbta-daterange-filter>
	</div>

	<div class="cbta-tbl my-feedback-tbl">
		<div class="columns">
			<div class="column col-12">
				<ngx-table
					[configuration]="configuration"
					[data]="submissions"
					[columns]="columns"
					[pagination]="pagination"
					(event)="onTableChanged($event)"
					[noResultsTemplate]="noResultsTemplate"
				>
				</ngx-table>
			</div>

			<ng-template #formNameTpl let-row>
				@if (!row.isTied) {
					<span class="font-bold">{{ formName(row) }}</span>
				} @else {
					<span>{{ formName(row) }}</span>
				}
			</ng-template>

			<ng-template #formTypeTpl let-row>
				@if (!row.isTied) {
					<span class="font-bold text-violet">{{ formType(row) }}</span>
				} @else {
					<span>{{ formType(row) }}</span>
				}
			</ng-template>

			<ng-template #instructorTpl let-row>
				<span>{{ fromLabel(row) }}</span>
			</ng-template>

			<ng-template #dateTpl let-row>
				<span class="text-violet">{{ formatDate(row.submittedAt) }}</span>
			</ng-template>

			<ng-template #actionTpl let-row>
				<div class="flex justify-center">
					<button class="aa-btn" data-variant="secondary" data-size="small" (click)="viewSubmission(row.id)">
						View
					</button>
				</div>
			</ng-template>

			<ng-template #noResultsTemplate>
				<td [attr.colspan]="columns.length" class="h-[180px] text-center">
					<span class="text-grey-40">No feedback submitted.</span>
				</td>
			</ng-template>
		</div>
	</div>
</div>
